module.exports = __webpack_public_path__ + "static/media/avatar_fox.0b054c2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_fox.png
// module id = 379
// module chunks = 0